exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-heading .wh-label{font-weight:600}.widget-heading .wh-subText{font-size:13px}", ""]);

